import React from "react";
import PropTypes from "prop-types";
import {object} from "yup";
import {useTranslation} from "@unibuddy/intl";
import {Autocomplete, FormGroup} from "@unibuddy/patron";
import {Query} from "@apollo/client/react/components";
import GetDomesticRegionByCountryIdQuery from "../../queries/getDomesticRegionByCountryIdQuery";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_DOMESTIC_REGION_REQUIRED} from "../../../../translations/validations";

const DomesticRegionAutocomplete = (props) => {
    const {t} = useTranslation(IntlNamespaces.VALIDATIONS);

    return (
        <Query query={GetDomesticRegionByCountryIdQuery} variables={{countryId: props.countryId}}>
            {({data, loading}) => {
                if (loading) {
                    return null;
                }
                return data && data.domesticRegions.length > 0 ? (
                    <FormGroup
                        initialValue={props.initialValue}
                        validation={object()
                            .nullable()
                            .required(
                                t(
                                    INTL_DOMESTIC_REGION_REQUIRED.key,
                                    INTL_DOMESTIC_REGION_REQUIRED.defaultValue,
                                ),
                            )}
                        id="domesticRegion"
                        label={props.label}
                    >
                        <Autocomplete
                            id={"domesticRegion"}
                            data-test-id="domestic-region"
                            options={data.domesticRegions}
                            labelKey="name"
                            {...props}
                        />
                    </FormGroup>
                ) : null;
            }}
        </Query>
    );
};

DomesticRegionAutocomplete.propTypes = {
    countryId: PropTypes.string.isRequired,
};

DomesticRegionAutocomplete.defaultProps = {
    label: "Domestic Region",
};

export default DomesticRegionAutocomplete;
